import React from 'react'

const Rankings: React.FC = () => {
	return (
		<h1 className='text-6xl font-bold text-sky-600 text-center p-10'>
			Rankings
		</h1>
	)
}

export default Rankings
